/* RESPONSIBLE TEAM: team-automation-foundations */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class SalesPlaybookController extends Controller {
  queryParams = ['open'];

  @tracked open: string | null = null;
}
